<template>
  <div class="header-containder">
    <div class="header">
      <div class="menu-user-info">
        <div class="menu-icon" @click="collapse">
          <i
            class="iconfont iconcaidan2"
            :class="{
              'hide-menu-icon': isCollapse,
              'show-menu-icon': !isCollapse,
            }"
          ></i>
        </div>
        <div class="route-user-info">
          <div class="route-logo">
            <div class="logo-name">{{ companyName }}</div>
            <bread></bread>
          </div>
          <div class="user-info">
            <el-dropdown placement="bottom" trigger="click">
              <span class="el-dropdown-link">
                <div class="user-img">
                  <i class="iconfont iconyonghu2"></i>
                </div>
                <div class="user-name">
                  {{ userRealName }}@{{ companyName }}
                  <i class="el-icon-caret-bottom"></i>
                </div>
              </span>
              <el-dropdown-menu class="user-dpd" slot="dropdown">
                <!-- <el-dropdown-item>
                  <div @click="changeHeadImg">更换头像</div>
                </el-dropdown-item> -->
                <el-dropdown-item>
                  <div @click="changePassWord">修改密码</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="loginOut">退出登录</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <tags></tags>
    </div>
    <change-pwd ref="changePwd" />
    <change-head-img ref="changeHeadImg" />
  </div>
</template>
<script>
import changePwd from "@/components/changePwd";
import changeHeadImg from "@/components/changeHeadImg";
import bread from "./bread";
import tags from "./tags";
import { logout } from "@/api/setting/member";
import { mapState } from "vuex";
import { getAertOrders } from "@/api/bussiness/order";
export default {
  components: { changePwd, changeHeadImg, bread, tags },
  data() {
    return {
      companyName: localStorage.getItem("X-TenantName"),
      userRealName: localStorage.getItem("X-UserRealName"),
      userName: localStorage.getItem("X-UserName"),
      intervalId: "",
    };
  },
  computed: {
    ...mapState({
      isCollapse: (state) => state.app.isCollapse,
    }),
  },

  methods: {
    collapse() {
      this.$store.commit("app/showLogo", false);
      setTimeout(() => {
        this.$store.commit("app/isCollapse", !this.isCollapse);
        setTimeout(() => {
          this.$store.commit("app/showLogo", true);
        }, 100);
      }, 0);
    },
    changeHeadImg() {
      this.$refs.changeHeadImg.chooseImage();
    },
    changePassWord() {
      this.$refs.changePwd.showForm(this.userName);
    },

    loginOut() {
      let token = localStorage.getItem("X-Token");
      logout(token).then(() => {
        localStorage.setItem("X-Token", "");
        localStorage.setItem("X-routes", "");
        this.$store.commit("routers", []);
        this.$router.push("/login");
      });
    },
  },
  mounted() {
    if (this.intervalId) {
      clearInterval(intervalId);
    }
    let that = this;
    this.intervalId = setInterval(function () {
      let token= localStorage.getItem("X-Token");
      if(!token) return;
      getAertOrders({}).then((res) => {
        if (res > 0) {
          var n = new Audio("/images/audio/new.mp3");
          n.play();
        }
      });
    }, 60000);
  },
};
</script>
<style lang='scss' scoped>
.header-containder {
  background: #f6f6f6;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  margin-bottom: 4px;
  .header {
    height: 100%;
    .menu-user-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;
      background: $head-bg;
      .menu-icon {
        height: 50px;
        width: 50px;
        cursor: pointer;
        line-height: 50px;
        text-align: center;
        i {
          display: inline-block;
          color: black;
          font-size: 27px;
        }
        .show-menu-icon {
          transform: rotate(0deg);
          transition: all 0.3s linear;
        }
        .hide-menu-icon {
          transform: rotate(180deg);
          transition: all 0.3s linear;
        }
        &:hover {
          box-shadow: 0px 0px 10px 1px #eee inset;
        }
      }
      .route-user-info {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .route-logo {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          .logo-name {
            margin-top: -3px;
            font-size: 22px;
            margin-left: 10px;
          }
        }
        .user-info {
          .el-dropdown-link {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding-right: 15px;
            cursor: pointer;
            user-select: none;
            .user-img {
              margin-right: 10px;
              i {
                font-size: 26px;
                color: black;
              }
            }
            .user-name {
              font-size: 17px;
              color: black;
            }
          }
        }
      }
    }
  }
}
</style>